import { useStore } from "../State/Store"
import {
  IconHolder,
  IconHolder2,
  MainContent,
  SubContent,
  TempFaves,
  TitleHolder,
  UI
} from "./FavouriteUI.style"
import { useSpring } from "react-spring"
import { FavouriteIcon } from "../../../ApartmentFinderConfig/Icons/DynamicIcons"
import { BlockLabelIcon } from "../../../ApartmentFinderConfig/CustomIcons"

import {
  useApartmentBedsByPlotNumber,
  useApartmentFloorLevelByPlotNumber
} from "../Utils/hooks"
import { Link } from "react-router-dom"

const bedsTypes = {
  1: "ONE",
  2: "TWO",
  3: "THREE",
  4: "FOUR"
}

function FavouriteUI({ show }) {
  const favourites = useStore(state => state.favourites)
  const favouritesActive = useStore(state => state.favouritesActive)
  const setFavouritesActive = useStore(state => state.setFavouritesActive)
  // const setActivateBlock = useStore(state => state.setActivateBlock)
  const setActiveApt = useStore(state => state.setActiveApt)
  const apartmentFinderActive = useStore(state => state.apartmentFinderActive)
  const removeFavourite = useStore(state => state.removeFavourite)

  // const flatType = useApartmentTypeByPlotNumber()
  const beds = useApartmentBedsByPlotNumber()
  const floor = useApartmentFloorLevelByPlotNumber()

  const props = useSpring({
    // left: show ? window.innerWidth - 300 : window.innerWidth,
    top: favouritesActive ? 0 : -window.innerHeight * 2.5
  })
  const toggleFavourites = () => {
    if (apartmentFinderActive) {
      setFavouritesActive(!favouritesActive)
      setActiveApt(null)
      // setActivateBlock(null)
    }
  }

  return (
    <>
      <IconHolder onClick={toggleFavourites}>
        <FavouriteIcon isFavourite={true} showNumber={true} />
        {/* <DynamicIcons callback={toggleFavourites} iconID={"favourite"} /> */}
      </IconHolder>
      <UI style={props}>
        {favourites.map((id, i) => (
          <TempFaves onClick={() => setActiveApt(id)}>
            <MainContent>
              <IconHolder2>
                <BlockLabelIcon id={id} />
              </IconHolder2>
              <TitleHolder>
                <h2>Floor {floor[id]}</h2>
                <h1>PLOT {id} </h1>
                <h3>{bedsTypes[beds[id]]} BED</h3>
              </TitleHolder>
            </MainContent>
            <SubContent>
              <div
                onClick={e => {
                  e.stopPropagation()
                  removeFavourite(id)
                }}
                style={{
                  height: "40px",
                  width: "40px",
                  margin: "30%",
                  marginTop: "50%",
                  transform: "translate(0, -50%)",
                  pointerEvents: "initial"
                }}
              >
                <FavouriteIcon isFavourite={true} />
              </div>
            </SubContent>
          </TempFaves>
        ))}
        <Link to={"/favourites"}>
          <div
            style={{
              bottom: "30px",
              margin: "2%",
              height: "77px",
              width: "77px",
              position: "absolute",
              // backgroundColor: "white",
              cursor: "pointer",
              userSelect: "none"
            }}
            // onClick={() => console.log("link")}
          >
            <svg
              id="Layer_1"
              data-name="Layer 1"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 128 128"
              width="100%"
            >
              <circle
                cx="66.85"
                cy="66.03"
                r="50.46"
                style={{ fill: "#bdb3b7" }}
              />
              <circle
                cx="61.19"
                cy="66.45"
                r="50.46"
                style={{
                  fill: "none",
                  stroke: "#3b1a53",
                  strokeMiterlimit: 10
                }}
              />
              <path
                d="M88.32,64.17v0a5.56,5.56,0,0,0-5.65-5.61A4.86,4.86,0,0,0,77.91,62a.35.35,0,0,1-.32.22.33.33,0,0,1-.32-.22,4.86,4.86,0,0,0-4.76-3.48,5.56,5.56,0,0,0-5.66,5.59v0c0,.74.1,7.3,10.74,12.71,10.63-5.41,10.76-12,10.73-12.7Z"
                style={{
                  fill: "none",
                  stroke: "#3b1a53",
                  strokeMiterlimit: 10
                }}
              />
              <path
                d="M53.56,84.11a.62.62,0,0,1-.44-.18L37.34,68.15a.62.62,0,0,1,0-.89L53.12,51.48a.63.63,0,0,1,.89.89L38.68,67.7,54,83a.65.65,0,0,1,0,.9A.64.64,0,0,1,53.56,84.11Z"
                style={{ fill: "#3b1a53" }}
              />
              <path
                d="M64.27,84.11a.62.62,0,0,1-.44-.18L48.05,68.15a.62.62,0,0,1,0-.89L63.83,51.48a.63.63,0,1,1,.89.89L49.39,67.7,64.72,83a.65.65,0,0,1,0,.9A.66.66,0,0,1,64.27,84.11Z"
                style={{ fill: "#3b1a53" }}
              />
            </svg>
          </div>
        </Link>
      </UI>
    </>
  )
}

export default FavouriteUI
